import { howlMapper } from 'config/constants/audio'
import { InhouseGameDetails } from 'config/types/game'
import React, { useEffect, useState } from 'react'
import { StyledInhouseGameContainer } from '../components/styled'
import { GameInHouseConfig } from '../config/types'
import { useInhouseSession } from '../Plinko/hooks'
import LimboBetSettings from './components/BetBoard'
import GameBoard from './components/GameBoard'
import { targetMultiplierMax, targetMultiplierMin } from './config'

const LimboGame: React.FC<GameInHouseConfig & { game: InhouseGameDetails }> = ({ volumeEnable, game, ...config }) => {
  const [isLocked, setIsLocked] = useState(false)

  const [targetMultiplier, setTargetMultiplier] = useState('2.00')

  const { gameSettings } = useInhouseSession({ game })

  useEffect(() => {
    // Init audio
    // eslint-disable-next-line no-unused-expressions
    howlMapper.LimboGameBetPlaying
    // eslint-disable-next-line no-unused-expressions
    howlMapper.LimboGameBetWin
  }, [])

  return (
    <StyledInhouseGameContainer>
      <LimboBetSettings
        isLocked={isLocked}
        setIsLocked={setIsLocked}
        volumeEnable={volumeEnable}
        targetMultiplier={Number(targetMultiplier)}
        disabled={Number(targetMultiplier) < targetMultiplierMin || Number(targetMultiplier) > targetMultiplierMax}
        game={game}
        gameSettings={gameSettings}
        {...config}
        width="100%"
        mt={['16px', '', '', '', '0']}
      />
      <GameBoard
        disabled={isLocked}
        volumeEnable={volumeEnable}
        game={game}
        targetMultiplier={targetMultiplier}
        onTargetMultiplierChanged={setTargetMultiplier}
      />
    </StyledInhouseGameContainer>
  )
}

const LimboGameMemorized = React.memo(LimboGame)

export default LimboGameMemorized
